import React, { useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { HeroSection } from '@/components/HeroSection';
import { AboutSection } from '@/components/AboutSection';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';

const BG_IMAGE = 'https://customer-assets.emergentagent.com/job_perfectbuild/artifacts/chmd9imm_d6776240-4dc4-45b1-b741-455b93d0f8fd%20%281%29.png';

export default function LandingPage() {
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: '/' }),
    }).catch(() => {});
  }, []);

  return (
    <>
      {/* Fixed background layer — pinned to viewport, never scrolls away */}
      <div
        className="landing-bg-layer"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />

      {/* Page content sits above the fixed layer */}
      <div className="min-h-screen" style={{ position: 'relative', zIndex: 1, backgroundColor: 'transparent' }}>
        <Navbar />
        <HeroSection />
        <AboutSection />
        <Footer />
        <Toaster theme="dark" richColors position="top-center" />
      </div>
    </>
  );
}
